// hooks/useLoaiTaiSan.ts
import { useQuery } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";

export interface TrangThaiThanhToan {
  value: number;
  name: string;
}

const fetchTrangThaiThanhToan = async (): Promise<TrangThaiThanhToan[]> => {
  const response = await axiosInstance.get<{
    data: TrangThaiThanhToan[];
  }>("/api/Master/trangthaithanhtoan");
  return response.data.data;
};

export const useTrangThaiThanhToan = () => {
  return useQuery<TrangThaiThanhToan[]>({
    queryKey: ["trangThaiThanhToan"],
    queryFn: fetchTrangThaiThanhToan,
    staleTime: 1000 * 60 * 5, // 5 phút
    refetchOnWindowFocus: false,
  });
};
